import React from "react";
import "../about/about.css";

import food from "../../assets/images/icons/food-delivery-icon.png";
import port from "../../assets/images/icons/goods-transport-icon.png";
import retail from "../../assets/images/icons/retail-distribution.png";
import flowers from "../../assets/images/icons/flowers-delivery-icon.png";

const servicesData = [
 {
  img: food,
  title: "Food Distributors",
  desc: "We support food distributors handling high-volume produce with reliable refrigerated transport. Our 7-ton and 10-ton trucks maintain stable cold chain logistics for safe delivery to hotels, restaurants, and supermarkets across Dubai and Abu Dhabi."
},
{
  img: port,
  title: "Port Shipment",
  desc: "We provide fast refrigerated transport near Jebel Ali Port and Khalifa Port for imported seafood, medicines, and temperature-sensitive goods. Our 5 to 10 ton fleet ensures precise temperature control and efficient, timely handling of high-volume shipments across the UAE"
},
{
  img: retail,
  title: "Retail Distribution",
  desc: "We support retail distribution of frozen food, dairy products, ice cream, and beverages with reliable refrigerated transport. Our fleet maintains stable temperature control and ensures timely delivery to retail outlets across Dubai , UAE and abu dhabi."
},
{
  img: flowers,
  title: "Fresh Flower Transport",
  desc: "We support fresh flower transport from farms and suppliers with reliable refrigerated logistics. Our trucks maintain stable temperature control and ensure safe delivery of fresh flowers and preserved across Dubai and Abu Dhabi without spoilage."
}
];

const RefrigeratedTruckIndustries = () => {
  return (
    <section className="ss-section" aria-labelledby="refrigerated-industries-heading">
      <div className="ss-container">

        {/* HEADER */}
        <div className="ss-header text-center" data-aos="fade-up">
          <h2 id="refrigerated-industries-heading">
            Industries in Dubai & Abu Dhabi Using Our Refrigerated Truck Rental Service
          </h2>

          <p data-aos="fade-up" data-aos-delay="150">
            Our refrigerated truck rental service supports high-frequency distribution for 
            <strong> food wholesalers, supermarket supply chains, central kitchens, and healthcare logistics</strong>. 
            Businesses rely on our fleet for <strong>reliable cold chain transport, consistent temperature control, 
            and on-time deliveries</strong> across Dubai, Abu Dhabi, and the UAE.
          </p>
        </div>

        {/* GRID */}
        <div className="ss-grid">
          {servicesData.map((item, i) => (
            <div
              key={i}
              className="ss-card"
              data-aos="zoom-in"
              data-aos-delay={i * 120}
            >
              <div className="ss-card-header">
                <img
                  src={item.img}
                  alt={item.title}
                  className="ss-card-icon"
                  loading="lazy"
                />
                <h3>{item.title}</h3>
              </div>

              <hr />

              <p>{item.desc}

                  <a
                  href="tel:+971544792905"
                  className="btn--primary bg-light text-dark btn-sm"
                >
                  Call Now
                </a>
                <a
                  href="https://wa.me/971544792905"
                  className="btn--primary"
                >
                  WhatsApp
                </a>
              </p>

            
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default RefrigeratedTruckIndustries;